import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs/internal/firstValueFrom";

export function loadConfig(http: HttpClient) {
  return () => firstValueFrom(
    http.get<any>('assets/config/env.config.json')
  ).then(config => {
    const {
      env = 'dev'
    } = config || {};
    (window as any).appConfig = config[env];
  });
}